import React, {useState, useEffect} from 'react';
import sizeMananager, {getSize, isMobile as findOutIfMobile} from './sizeManagement';
import {useHistory, useLocation} from 'react-router-dom';

export const GlobalContext = React.createContext();

export default function GlobalProvider({children}) {
	const [size, setSize] = useState(getSize());
	const [isMobile, setIsMobile] = useState(findOutIfMobile(getSize()));
	const [serverOrigin, setServerOrgin] = useState(
		ReactIsInDevelomentMode() ? 'http://localhost:3002' : 'https://the-brugmethod-lowlands-10163.herokuapp.com'
	);
	const [emailServer, setEmailServer] = useState(
		ReactIsInDevelomentMode() ? 'http://localhost:3005' : 'https://brug-mail-server.herokuapp.com'
	);
	const [currentLocation, setCurrentLocation] = useState(getLocation());
	const history = useHistory();

	useEffect(() => {
		let unListen = history.listen((location, action) => {
			setCurrentLocation(getLocation(location.pathname));
		});

		window.addEventListener('resize', () => {
			sizeMananager(setSize);
			setIsMobile(findOutIfMobile(getSize()));
		});
		return () => {
			unListen();
		};
	}, []);

	const [navHeight, setNavHeight] = useState('4rem');
	const [lgDskSze, setLgDskSze] = useState('1rem');
	const [rgDskSze, setRgDskSze] = useState('0.5rem');
	const [minimumMargin, setMinimumMargin] = useState(1);
	const [rerender, setRerender] = useState(true);
	const [user, setUser] = useState(null);
	const [userLoading, setUserLoading] = useState(true);

	return (
		<GlobalContext.Provider
			value={{
				size: size,
				setSize: setSize,
				navHeight: navHeight,
				setNavHeight: setNavHeight,
				lgDskSze: lgDskSze,
				setLgDskSze: setLgDskSze,
				rgDskSze: rgDskSze,
				rgDskSze: setRgDskSze,
				minimumMargin: minimumMargin,
				setMinimumMargin: setMinimumMargin,
				currentLocation: currentLocation,
				getCurrentLocation: getLocation,
				isMobile: isMobile,
				setIsMobile: setIsMobile,
				forceRerender: forceRerender,
				serverOrigin: serverOrigin,
				setServerOrgin: setServerOrgin,
				emailServer: emailServer,
				setEmailServer: setEmailServer,
				user: user,
				setUser: setUser,
				userLoading: userLoading,
				setUserLoading: setUserLoading,
			}}
		>
			{children}
		</GlobalContext.Provider>
	);

	function getLocation(path) {
		path = path || window.location.pathname;
		let location = 'home';
		switch (path) {
			case '/':
				location = 'index';
				break;
			case '/home':
				location = 'home';
				break;
			case '/ccmrs':
				location = 'ccmrs';
				break;
			case '/support':
				location = 'support';
				break;
			case '/signup':
				location = 'index'; /* This app will treat sign up and sign in like they are the index page */
				break;
			case '/signin':
				location = 'index'; /* This app will treat sign up and sign in like they are the index page */
				break;
			default:
				location = 'home';
				break;
		}

		return location;
	}

	function forceRerender() {
		setRerender(!rerender);
	}

	function ReactIsInDevelomentMode() {
		return '_self' in React.createElement('div');
	}
}
